<h1 mat-dialog-title>{{'Lieferanten-Artikel-Beziehung ' + (data?.vendorArticle ? 'editieren' : 'erstellen')}}</h1>
@if (data?.disableClose) {
  <p>Es muss ein Lieferantenartikel erstellt werden, um fortzufahren.</p>
}

<form mat-dialog-content [formGroup]="vendorArticleForm" (keydown.enter)="save()">
  <mat-form-field appearance="fill" formGroupName="vendor">
    <mat-label>Lieferant</mat-label>
    <mat-select formControlName="id">
      <mat-option>
        <ngx-mat-select-search [formControl]="vendorFilterCtrl"></ngx-mat-select-search>
      </mat-option>
      @for (vendor of filteredVendors | async; track vendor) {
        <mat-option [value]="vendor.id">
          {{vendor.organization.name}} ({{vendor.vendorNumber}})
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Lieferanten-Artikelnummer</mat-label>
    <input matInput formControlName="vendorArticleNumber">
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Preis</mat-label>
    <input matInput formControlName="price" type="number">
    <mat-icon matSuffix>euro_symbol</mat-icon>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Verpackungseinheit</mat-label>
    <input matInput formControlName="packagingUnit" type="number">
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Hersteller</mat-label>
    <input matInput formControlName="manufacturerName">
  </mat-form-field>

  <div class="main-vendor-article-checkbox-container">
    <mat-checkbox formControlName="isMainVendorArticle"
      color="primary">
      Hauptlieferant für diesen Artikel
    </mat-checkbox>
    @if (showMainVendorArticleHint) {
      <mat-hint>Der Hauptlieferant kann nur gewechselt werden, indem ein neuer Hauptlieferant aktiviert wird.</mat-hint>
    }
  </div>
</form>

<div mat-dialog-actions>
  @if (!data?.disableClose) {
    <button mat-flat-button (click)="cancel()">Abbrechen</button>
  }
  <button mat-flat-button color="primary" (click)="save()" [disabled]="vendorArticleForm.invalid" class="save-btn">Bestätigen</button>
</div>
